import type { BookingReservationPartyLookup } from '../Types/bookingReservationTable.types';

export interface ReservationPartyLookupShape {
  id: number;
  label?: string;
  email?: string;
  phone?: string;
  taxId?: string;
  addressSummary?: string;
}

export const mapReservationPartyToBookingReservationPartyLookup = (
  party: ReservationPartyLookupShape | undefined | null
): BookingReservationPartyLookup | undefined => {
  if (!party) {
    return undefined;
  }

  return {
    id: party.id,
    label: party.label?.trim() ?? '',
    email: party.email?.trim() ?? '',
    phone: party.phone?.trim() ?? '',
    taxId: party.taxId?.trim() ?? '',
    addressSummary: party.addressSummary?.trim() ?? '',
    sourceType: 'party-api',
  };
};
